module.exports = __webpack_public_path__ + "img/弹力锁.619ebc03.png";